module.exports = __webpack_public_path__ + "img/secondary_11x4_z16.5d37372b.svg";